import { MoonIcon } from '@heroicons/react/24/outline';

export function OOOCard(): JSX.Element {
  return (
    <div className="h-[80px] flex items-center">
      <div className="flex flex-col items-center w-full bg-blue-50 rounded-lg py-4">
        <MoonIcon className="h-6 w-6 mb-2 text-blue-500" />
        <span className="text-gray-900 text-sm ">Out of Office</span>
      </div>
    </div>
  );
}
